<div class="d-flex h-90">
  <div class="login-container m-auto">
    <div class="card boxshadow">

      <div class="card-header bg-primary text-white">
        <i class="fa fa-shield"></i> Enable MFA
      </div>

      <div class="card-body">

        <div *ngIf="qrImage" class="text-center mb-3">
          <p>Scan using Google / Microsoft Authenticator</p>
          <img [src]="qrImage" class="img-fluid border p-2 bg-white" />
        </div>

        <div *ngIf="manualCode" class="text-center mb-3">
          <small>Manual key: <b>{{ manualCode }}</b></small>
        </div>

        <form #f="ngForm" (ngSubmit)="confirm()">

          <div class="mb-3">
            <input type="text"
                   name="code"
                   maxlength="6"
                   class="form-control text-center"
                   [(ngModel)]="code"
                   required />
          </div>

          <button type="submit"
                  class="btn btn-primary w-100"
                  [disabled]="isLoading">

            <i *ngIf="isLoading"
               class="fa fa-circle-o-notch fa-spin"></i>

            {{ isLoading ? 'Verifying...' : 'Confirm & Enable' }}
          </button>

        </form>

      </div>
    </div>
  </div>
</div>
